export class NbnOrder {
  constructor({
    wholesalerAccountNumber = 0,
    customerRef = "",
    customerAuthRef = "",
    orderType = "",
    productType = "",
    customerFirstname = "",
    customerSurname = "",
    customerContactEmail = "",
    customerContactNumber = "",
    endUserType = "",
    informedConsent = "",
    partyId = "",
    avcId = "",
    ntdId = "",
    cpiId = "",
    portId = "",
    cvcId = "",
    bandwidthProfile = "",
    dslStabilityProfile = "",
    interfaceBandwidth = "",
    interfaceType = "",
    ovcType = "",
    tpid = "",
    locationId = "",
    contactNumber = "1800828668",
    contactFirstname = "2SG",
    contactSurname = "Support",
    customerEmail = "",
    afterHoursSiteVisit = "",
    inductionRequired = "",
    securityClearance = "",
    tradingName = "",
    heritageSite = "",
    serviceRestorationSla = "",
    contractTerm = "",
    appointmentId = "",
    productId = "",
    customerAuthorityDate = "",
    preferredBTDMounting = "",
    preferredPowerSupply1 = "",
    routeType = "",
    nniGroupId = "",
    cosHighBandwidth = "",
    mappingMode = "",
    ovcTransientId = "",
    notes = "",
    serviceClass = "",
    radiusUsername = "",
    radiusPassword = "",
    staticIP = false,
    nbnAssureRequired = "No",
    simRequired = "No",
    hardwareRequired = "No",
    onHold = false,
    id = "",
    connectionDateRequire = "No",
    scheduledDateTime = "",
    nbnOrderId = "",
    status = "",
    replaceNtd = false,
    sameHardwareContact = false,
    macAddress = "",
    serialNumber = "",
    existingRadiusUsername = "",
    existingRadiusPassword = "",
    ipRange = "",
    productTemplate = "",
    tagVlan = null,
    isIpoe = true,
    cTag = "",
    sTag = "",
    ntdType = "",
    ntdModifications = "",
    existingNtdId = "",
  } = {}) {
    (this.wholesalerAccountNumber = wholesalerAccountNumber),
      (this.customerRef = customerRef),
      (this.customerAuthRef = customerAuthRef),
      (this.orderType = orderType),
      (this.productType = productType),
      (this.customerFirstname = customerFirstname),
      (this.customerSurname = customerSurname),
      (this.customerContactEmail = customerContactEmail),
      (this.customerContactNumber = customerContactNumber),
      (this.endUserType = endUserType),
      (this.informedConsent = informedConsent),
      (this.partyId = partyId),
      (this.avcId = avcId),
      (this.ntdId = ntdId),
      (this.cpiId = cpiId),
      (this.portId = portId),
      (this.cvcId = cvcId),
      (this.bandwidthProfile = bandwidthProfile),
      (this.dslStabilityProfile = dslStabilityProfile),
      (this.interfaceBandwidth = interfaceBandwidth),
      (this.interfaceType = interfaceType),
      (this.ovcType = ovcType),
      (this.tpid = tpid),
      (this.locationId = locationId),
      (this.contactNumber = contactNumber),
      (this.contactFirstname = contactFirstname),
      (this.contactSurname = contactSurname),
      (this.customerEmail = customerEmail),
      (this.afterHoursSiteVisit = afterHoursSiteVisit),
      (this.inductionRequired = inductionRequired),
      (this.securityClearance = securityClearance),
      (this.tradingName = tradingName),
      (this.heritageSite = heritageSite),
      (this.serviceRestorationSla = serviceRestorationSla),
      (this.contractTerm = contractTerm),
      (this.appointmentId = appointmentId),
      (this.productId = productId),
      (this.customerAuthorityDate = customerAuthorityDate),
      (this.preferredBTDMounting = preferredBTDMounting),
      (this.preferredPowerSupply1 = preferredPowerSupply1),
      (this.routeType = routeType),
      (this.nniGroupId = nniGroupId),
      (this.cosHighBandwidth = cosHighBandwidth),
      (this.mappingMode = mappingMode),
      (this.ovcTransientId = ovcTransientId),
      (this.notes = notes),
      (this.serviceClass = serviceClass);
    this.radiusUsername = radiusUsername;
    this.radiusPassword = radiusPassword;
    this.staticIP = staticIP;
    this.nbnAssureRequired = nbnAssureRequired;
    this.simRequired = simRequired;
    this.hardwareRequired = hardwareRequired;
    this.onHold = onHold;
    this.id = id;
    this.connectionDateRequire = connectionDateRequire;
    this.scheduledDateTime = scheduledDateTime;
    this.nbnOrderId = nbnOrderId;
    this.status = status;
    this.replaceNtd = replaceNtd;
    this.macAddress = macAddress;
    this.serialNumber = serialNumber;
    this.sameHardwareContact = sameHardwareContact;
    this.existingRadiusUsername = existingRadiusUsername;
    this.existingRadiusPassword = existingRadiusPassword;
    this.ipRange = ipRange;
    this.productTemplate = productTemplate;
    this.tagVlan = tagVlan;
    this.isIpoe = isIpoe;
    this.cTag = cTag;
    this.sTag = sTag;
    this.ntdType = ntdType;
    this.ntdModifications = ntdModifications;
    this.existingNtdId = existingNtdId;
  }
}

export function createNbnOrder(data) {
  return Object.freeze(new NbnOrder(data));
}
